import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { createClient } from '../../lib/supabase/client';
import DashboardLayout from '../components/layout/DashboardLayout';
import { CreditCard, ExternalLink } from 'lucide-react';
import '../components/styles.css';

export default function Qonto() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const supabase = createClient();
        const { data: { user: currentUser } } = await supabase.auth.getUser();

        if (!currentUser) {
          navigate('/crm/login');
          return;
        }
      } catch (error) {
        console.error('Erreur d\'authentification:', error);
        navigate('/crm/login');
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, [navigate]);

  if (loading) {
    return (
      <DashboardLayout>
        <div className="text-center py-8">Chargement...</div>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">Qonto</h1>
          <p className="mt-2 text-gray-600">Intégration bancaire Qonto</p>
        </div>

        <div className="bg-white shadow-sm rounded-lg p-8">
          <div className="text-center space-y-4">
            <CreditCard className="h-16 w-16 text-primary-600 mx-auto" />
            <h2 className="text-2xl font-semibold text-gray-900">Intégration Qonto</h2>
            <p className="text-gray-600 max-w-md mx-auto">
              Connectez votre compte Qonto pour synchroniser automatiquement vos transactions bancaires,
              vos factures et vos paiements.
            </p>
            
            <div className="mt-8 space-y-4">
              <a
                href="https://qonto.com"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors"
              >
                <ExternalLink className="h-5 w-5" />
                Se connecter à Qonto
              </a>
            </div>

            <div className="mt-12 pt-8 border-t border-gray-200">
              <h3 className="text-lg font-semibold mb-4">Fonctionnalités à venir</h3>
              <ul className="text-left max-w-md mx-auto space-y-2 text-gray-600">
                <li className="flex items-start gap-2">
                  <span className="text-primary-600">•</span>
                  <span>Synchronisation automatique des transactions</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-primary-600">•</span>
                  <span>Rapprochement bancaire automatique</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-primary-600">•</span>
                  <span>Suivi des paiements en temps réel</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-primary-600">•</span>
                  <span>Export des relevés bancaires</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-primary-600">•</span>
                  <span>Tableau de bord financier</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
}
